<script setup lang="ts">
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
</script>

<template>
  <div>
    <button class="tw-rounded-full tw-bg-namaBackground-bright-dark dark:tw-bg-namaBackground-deep-light tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-w-8 tw-h-8"
            @click.stop="useNamaFlagsStore().toggleDarkMode">
      <svg class="tw-w-4 tw-h-4 tw-hidden dark:tw-block" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
        <path class="tw-fill-black"
              d="M7 0h2v2H7V0Zm5.88 1.637 1.414 1.415-1.415 1.413-1.414-1.414 1.415-1.414ZM14 7h2v2h-2V7Zm-1.05 7.433-1.415-1.414 1.414-1.414 1.415 1.413-1.414 1.415ZM7 14h2v2H7v-2Zm-4.02.363L1.566 12.95l1.415-1.414 1.414 1.415-1.415 1.413ZM0 7h2v2H0V7Zm3.05-5.293L4.465 3.12 3.05 4.535 1.636 3.121 3.05 1.707Z"/>
        <path class="tw-fill-black" d="M8 4C5.8 4 4 5.8 4 8s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4Z"/>
      </svg>
      <svg class="tw-w-4 tw-h-4 tw-block dark:tw-hidden" width="16" height="16" xmlns="http://www.w3.org/2000/svg">
        <path class="tw-fill-white" d="M6.2 2C3.2 2.8 1 5.6 1 8.9 1 12.8 4.2 16 8.1 16c3.3 0 6-2.2 6.9-5.2C9.7 12.2 4.8 7.3 6.2 2Z"/>
        <path class="tw-fill-white"
              d="M12.5 6a.625.625 0 0 1-.625-.625 1.252 1.252 0 0 0-1.25-1.25.625.625 0 1 1 0-1.25 1.252 1.252 0 0 0 1.25-1.25.625.625 0 1 1 1.25 0c.001.69.56 1.249 1.25 1.25a.625.625 0 1 1 0 1.25c-.69.001-1.249.56-1.25 1.25A.625.625 0 0 1 12.5 6Z"/>
      </svg>
    </button>
  </div>
</template>

<style scoped>

</style>
